import type { AppConfig } from "../../composables/ConfigStore/useConfigStore";
import type { DebugAppConfig, DebugConfigAdapter } from "./types";
import { markRaw } from "vue";
import { useConfigStore } from "../../composables/ConfigStore/useConfigStore";

/**
 * The debug tools adapter of Web, CMS and Integrations: the override of the shared config store, and its developer
 * mode (`developerMode` in localStorage) as the debug mode.
 */
export function useDebugConfigAdapter(): DebugConfigAdapter {
  const store = useConfigStore();

  return markRaw({
    config: store.config,
    overrideConfig: store.overrideConfig,
    setOverrideConfig: (config: DebugAppConfig) => store.setOverrideConfig(config as unknown as AppConfig),
    reset: store.reset,
    debugMode: store.developerMode,
  });
}
